import {Product} from "./Product";
import {Menu} from "./Menu";
export class MenuOrdered {
    productList: Product[];
    number: number;
    menu: Menu;
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/model/MenuOrdered.ts